module.exports = __webpack_public_path__ + "550119d596b7065c85404b3c0b4a111d.svg";